{
  "seo": {
    "title": "Быстренко.ру — Внедрение amoCRM под ключ от 5 дней",
    "description": "Сертифицированный партнёр amoCRM. Внедрение CRM под ключ от 5 дней с гарантией результата в договоре. 350+ успешных проектов, настройка воронок, автоматизация и интеграции.",
    "keywords": "внедрение amoCRM, настройка amoCRM, автоматизация amoCRM, партнёр amoCRM, сертифицированный партнёр amoCRM, настройка воронок продаж",
    "canonicalPath": "/"
  },
  "hero": {
    "badge": "Сертифицированный партнёр amoCRM",
    "title": "Внедрим **amoCRM** под ключ **от 5 дней** с гарантией результата",
    "lead": "Мы знаем как сделать, чтобы вы перестали терять клиентов.",
    "text": "Настроим воронки, автоматизируем рутину, обучим команду и дадим поддержку 24/7. Ваши менеджеры начнут закрывать на 40% больше сделок.",
    "primaryCta": {
      "label": "Получить бесплатный аудит",
      "href": "#contact"
    },
    "secondaryCta": {
      "label": "Смотреть кейсы",
      "href": "#cases"
    },
    "stats": [
      {
        "value": "350+",
        "label": "Внедрений amoCRM"
      },
      {
        "value": "от 5 дней",
        "label": "Срок запуска"
      },
      {
        "value": "40%",
        "label": "Рост конверсии"
      },
      {
        "value": "100%",
        "label": "Гарантия результата"
      }
    ],
    "preview": {
      "caption": "amoCRM — Воронка продаж",
      "stages": [
        {
          "stage": "Новые заявки",
          "count": 24,
          "percent": 100,
          "tone": "stone-800"
        },
        {
          "stage": "Квалификация",
          "count": 18,
          "percent": 75,
          "tone": "stone-700"
        },
        {
          "stage": "Коммерческое предложение",
          "count": 11,
          "percent": 46,
          "tone": "stone-600"
        },
        {
          "stage": "Переговоры",
          "count": 7,
          "percent": 29,
          "tone": "stone-500"
        },
        {
          "stage": "Закрытые сделки",
          "count": 5,
          "percent": 21,
          "tone": "orange-600"
        }
      ],
      "metrics": [
        {
          "label": "Конверсия",
          "value": "21%",
          "icon": "ri-arrow-up-line",
          "tone": "green"
        },
        {
          "label": "Ср. чек",
          "value": "₽84к",
          "icon": "ri-money-dollar-circle-line",
          "tone": "amber"
        },
        {
          "label": "Цикл сделки",
          "value": "12 дн",
          "icon": "ri-time-line",
          "tone": "stone"
        }
      ]
    }
  },
  "services": {
    "badge": "Услуги",
    "title": "Всё для роста ваших продаж",
    "subtitle": "Комплексный подход: от настройки CRM до автоматизации всех процессов и обучения команды",
    "items": [
      {
        "icon": "ri-settings-3-line",
        "title": "Внедрение amoCRM под ключ",
        "text": "Полная настройка CRM под ваш бизнес: воронки продаж, поля, теги, права доступа, интеграции. Запускаем за 5–14 дней.",
        "tag": "Старт от 5 дней"
      },
      {
        "icon": "ri-robot-line",
        "title": "Автоматизация бизнес-процессов",
        "text": "Роботы, триггеры, автозадачи, автоматические письма и SMS. Ваши менеджеры занимаются продажами, а не рутиной.",
        "tag": "Экономия 3+ часов/день"
      },
      {
        "icon": "ri-links-line",
        "title": "Интеграции и API",
        "text": "Подключим сайт, мессенджеры, телефонию, 1С, склад, маркетплейсы. Все данные в одном месте — ничего не теряется.",
        "tag": "50+ интеграций"
      },
      {
        "icon": "ri-bar-chart-grouped-line",
        "title": "Аналитика и отчётность",
        "text": "Дашборды, KPI, воронки, прогнозы продаж. Видите узкие места и принимаете решения на основе данных, а не ощущений.",
        "tag": "Real-time данные"
      },
      {
        "icon": "ri-graduation-cap-line",
        "title": "Обучение команды",
        "text": "Онлайн и офлайн тренинги для менеджеров и руководителей. Видеокурсы, инструкции, тесты. Команда работает уверенно с первого дня.",
        "tag": "Сертификаты amoCRM"
      },
      {
        "icon": "ri-customer-service-2-line",
        "title": "Поддержка и развитие",
        "text": "Техподдержка 24/7, доработки под новые задачи, регулярные аудиты. Мы не исчезаем после внедрения — растём вместе с вами.",
        "tag": "Поддержка 24/7"
      }
    ]
  },
  "solutions": {
    "badge": "Решения",
    "title": "Готовые решения для amoCRM",
    "subtitle": "Расширяем возможности вашей CRM проверенными инструментами — от быстрой копии сделок до умного подбора по параметрам",
    "cardLinkLabel": "Подробнее",
    "spotlight": {
      "badge": "Новинка",
      "icon": "ri-bar-chart-grouped-line",
      "title": "Аналитика и отчётность",
      "text": "AI-аналитик с отчётами в Telegram, сквозная аналитика, дашборды в реальном времени. Видите узкие места воронки и принимаете решения на основе данных.",
      "href": "/analytics",
      "linkLabel": "Узнать подробнее"
    }
  },
  "process": {
    "badge": "Процесс",
    "title": "Как мы работаем",
    "subtitle": "Прозрачный процесс без сюрпризов — вы знаете что происходит на каждом этапе",
    "steps": [
      {
        "num": "01",
        "icon": "ri-clipboard-line",
        "title": "Бесплатный аудит и стратегия",
        "text": "Изучаем ваш бизнес, текущие процессы и точки потери клиентов. Составляем детальный план внедрения с конкретными метриками результата."
      },
      {
        "num": "02",
        "icon": "ri-settings-4-line",
        "title": "Настройка и интеграции",
        "text": "Настраиваем amoCRM под ваши процессы: воронки, поля, автоматизации, интеграции с сайтом, телефонией и мессенджерами."
      },
      {
        "num": "03",
        "icon": "ri-rocket-line",
        "title": "Обучение и запуск",
        "text": "Проводим обучение для менеджеров и руководителей. Запускаем систему в боевом режиме и контролируем первые недели работы."
      },
      {
        "num": "04",
        "icon": "ri-customer-service-2-line",
        "title": "Поддержка и рост",
        "text": "После запуска мы остаёмся рядом. Техподдержка 24/7, ежемесячные аудиты, доработки под новые задачи."
      }
    ]
  },
  "cases": {
    "badge": "Кейсы",
    "title": "Результаты наших клиентов",
    "subtitle": "Реальные цифры до и после внедрения amoCRM",
    "items": [
      {
        "industry": "Автодилер",
        "icon": "ri-car-line",
        "result": "+67% конверсия",
        "period": "3 месяца",
        "desc": "Настроили воронку для тест-драйвов и покупки. Автоматизировали follow-up после визита. Конверсия выросла с 12% до 20%.",
        "metrics": [
          {
            "label": "Конверсия",
            "before": "12%",
            "after": "20%"
          },
          {
            "label": "Время ответа",
            "before": "4 часа",
            "after": "8 мин"
          }
        ]
      },
      {
        "industry": "Медицина",
        "icon": "ri-heart-pulse-line",
        "result": "+43% записей",
        "period": "2 месяца",
        "desc": "Интегрировали amoCRM с сайтом и мессенджерами. Автоматические напоминания снизили неявки на 60%.",
        "metrics": [
          {
            "label": "Записей в месяц",
            "before": "340",
            "after": "487"
          },
          {
            "label": "Неявки",
            "before": "28%",
            "after": "11%"
          }
        ]
      },
      {
        "industry": "Строительство",
        "icon": "ri-building-2-line",
        "result": "×2.3 выручка",
        "period": "6 месяцев",
        "desc": "Выстроили систему работы с тёплой базой и повторными продажами. Выручка выросла в 2.3 раза без увеличения штата.",
        "metrics": [
          {
            "label": "Выручка",
            "before": "₽4.2М",
            "after": "₽9.7М"
          },
          {
            "label": "Менеджеров",
            "before": "8",
            "after": "8"
          }
        ]
      },
      {
        "industry": "Онлайн-образование",
        "icon": "ri-book-open-line",
        "result": "+89% доходимость",
        "period": "1 месяц",
        "desc": "Настроили автоматические цепочки писем и сообщений. Доходимость до конца курса выросла с 34% до 64%.",
        "metrics": [
          {
            "label": "Доходимость",
            "before": "34%",
            "after": "64%"
          },
          {
            "label": "Отток",
            "before": "41%",
            "after": "19%"
          }
        ]
      },
      {
        "industry": "Недвижимость",
        "icon": "ri-home-4-line",
        "result": "+38% сделок",
        "period": "4 месяца",
        "desc": "Объединили все источники лидов в одну воронку. Количество закрытых сделок выросло на 38% при том же трафике.",
        "metrics": [
          {
            "label": "Сделок/мес",
            "before": "24",
            "after": "33"
          },
          {
            "label": "Потерянных лидов",
            "before": "35%",
            "after": "8%"
          }
        ]
      },
      {
        "industry": "Логистика",
        "icon": "ri-truck-line",
        "result": "−70% рутины",
        "period": "3 недели",
        "desc": "Автоматизировали создание заявок, уведомления клиентам и документооборот. Скорость обработки выросла в 4 раза.",
        "metrics": [
          {
            "label": "Время обработки",
            "before": "45 мин",
            "after": "11 мин"
          },
          {
            "label": "Ручных операций",
            "before": "120/день",
            "after": "36/день"
          }
        ]
      }
    ]
  },
  "pricing": {
    "badge": "Тарифы",
    "title": "Прозрачные цены без скрытых платежей",
    "subtitle": "Фиксированная стоимость. Бесплатный аудит перед стартом",
    "popularLabel": "ПОПУЛЯРНЫЙ",
    "perPeriod": "разово",
    "plans": [
      {
        "name": "Старт",
        "price": "49 900",
        "period": "разово",
        "description": "Быстрый запуск для малого бизнеса",
        "features": [
          "Настройка 1 воронки продаж",
          "До 5 пользователей",
          "Базовые интеграции (сайт, почта)",
          "Перенос данных из Excel",
          "Обучение команды (4 часа)",
          "Поддержка 1 месяц"
        ],
        "cta": "Начать",
        "highlight": false
      },
      {
        "name": "Бизнес",
        "price": "119 900",
        "period": "разово",
        "description": "Полноценное внедрение под ключ",
        "features": [
          "До 5 воронок продаж",
          "До 25 пользователей",
          "Телефония, мессенджеры, 1С",
          "Автоматизация процессов",
          "Аналитика и дашборды",
          "Обучение команды (16 часов)",
          "Поддержка 3 месяца"
        ],
        "cta": "Выбрать план",
        "highlight": true
      },
      {
        "name": "Корпоратив",
        "price": "от 249 900",
        "period": "разово",
        "description": "Для крупных компаний и холдингов",
        "features": [
          "Неограниченные воронки",
          "Неограниченные пользователи",
          "Кастомные интеграции и API",
          "Разработка виджетов",
          "Выделенный менеджер проекта",
          "Поддержка 12 месяцев"
        ],
        "cta": "Обсудить проект",
        "highlight": false
      }
    ],
    "footnote": {
      "text": "Не уверены какой план подходит?",
      "linkLabel": "Получите бесплатный аудит",
      "linkHref": "#contact",
      "after": "— мы подберём оптимальное решение"
    }
  },
  "faq": {
    "badge": "FAQ",
    "title": "Частые вопросы",
    "subtitle": "Не нашли ответ? Напишите нам — ответим за 15 минут",
    "items": [
      {
        "q": "Сколько времени занимает внедрение amoCRM?",
        "a": "Базовое внедрение занимает от 5 рабочих дней. Полноценный проект с интеграциями и автоматизацией — 2–4 недели. Сроки фиксируются в договоре и не переносятся без вашего согласия."
      },
      {
        "q": "Нужно ли покупать лицензию amoCRM отдельно?",
        "a": "Да, лицензия amoCRM приобретается отдельно напрямую у amoCRM. Мы помогаем выбрать оптимальный тариф и можем оформить покупку через нас со скидкой партнёра."
      },
      {
        "q": "Что входит в гарантию результата?",
        "a": "Мы гарантируем достижение согласованных KPI в течение 90 дней после запуска. Если показатели не достигнуты — дорабатываем бесплатно до результата. Конкретные метрики прописываются в договоре."
      },
      {
        "q": "Работаете ли вы с компаниями из других городов?",
        "a": "Да, мы работаем удалённо по всей России и СНГ. Все встречи проводим в Zoom/Telegram, документы подписываем электронно. Более 60% наших клиентов — из других городов."
      },
      {
        "q": "Что будет, если нам понадобятся доработки после внедрения?",
        "a": "Все тарифы включают период поддержки (от 1 до 12 месяцев). После его окончания доработки выполняются по часовой ставке или в рамках абонентского обслуживания."
      },
      {
        "q": "Можно ли перенести данные из другой CRM или Excel?",
        "a": "Да, мы переносим данные из любых источников: Excel, Google Sheets, Bitrix24, Salesforce, 1С и других систем. Перенос данных включён во все тарифы."
      },
      {
        "q": "Как проходит обучение команды?",
        "a": "Обучение проводится онлайн в формате живых сессий с записью. Каждый сотрудник получает доступ к видеокурсу и инструкциям. Для руководителей — отдельный блок по аналитике."
      }
    ]
  },
  "contact": {
    "badge": "Бесплатный аудит",
    "title": "Перестаньте терять **клиентов** уже **сегодня**",
    "text": "Оставьте заявку — проведём бесплатный аудит вашего отдела продаж и покажем, где вы теряете деньги прямо сейчас.",
    "bullets": [
      {
        "icon": "ri-time-line",
        "text": "Ответим в течение 15 минут"
      },
      {
        "icon": "ri-shield-check-line",
        "text": "Гарантия результата в договоре"
      },
      {
        "icon": "ri-gift-line",
        "text": "Аудит бесплатно — без обязательств"
      }
    ],
    "formTitle": "Заявка на бесплатный аудит",
    "formSubtitle": "Заполните форму — свяжемся в течение 15 минут",
    "form": {
      "fields": {
        "name": "Имя",
        "namePlaceholder": "Иван Иванов",
        "email": "Email",
        "emailPlaceholder": "amo@vnedrim-crm.ru",
        "phone": "Телефон",
        "phonePlaceholder": "+7 (___) ___-__-__",
        "company": "Компания и сфера деятельности",
        "companyPlaceholder": "ООО Ромашка — строительство",
        "message": "Задача или вопрос",
        "messagePlaceholder": "Расскажите о вашей задаче..."
      },
      "submitLabel": "Получить бесплатный аудит",
      "submittingLabel": "Отправляем...",
      "errors": {
        "tooLong": "Сообщение не должно превышать 500 символов",
        "generic": "Не удалось отправить заявку. Попробуйте ещё раз.",
        "success": "Заявка отправлена! Свяжемся с вами в течение 15 минут"
      }
    }
  }
}
